
function ensureTrailingSlash (url) {
  return url.replace(/\/+$/, '') + '/'
}

function ensureNoTrailingSlash (url) {
  return url.replace(/\/+$/, '')
}

// Lei Search base urls
export const baseURL = ensureTrailingSlash(process.env.LEISEARCH_API_BASE_URL)
export const challengeURL = ensureTrailingSlash(process.env.LEISEARCH_API_CHALLENGE)

// Lei Search export data urls
export const exportFullFileUrl = ensureTrailingSlash(process.env.EXPORT_FULL_FILE)
export const exportSearchResultsUrl = ensureTrailingSlash(process.env.EXPORT_SEARCH_RESULTS)

// Google maps api key
export const googleKey = process.env.GOOGLE_API_KEY

// Cookie bot key
export const cookieBotKey = process.env.COOKIEBOT_KEY

// credentials
export const vleiReportingURL = ensureTrailingSlash(process.env.VLEI_API_BASE_URL)

// DG Dashboard
export const dgDashboardURL = ensureNoTrailingSlash(process.env.DG_DASHBOARD_BASE_URL)



// WEBPACK FOOTER //
// ./src/constants/api.js